export { ConfirmInput, type ConfirmInputProps } from './ConfirmInput.js';
